

/* ============
* Login Index Page
* ============
*
* Page where the user can login.
*/
import {getPublicJobs} from '@/api/service';
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Cell from 'vux/src/components/cell/index.vue'



export default {

data() {
return {
list:['条件查询', '分类查询'],
index:0,
demo2:'条件查询',
/*commonList:[{key:0,value:'不限'},{key:1,value:'男'},{key:2,value:'女'}],*/
educationList:[{key:0,value:'不限'},{key:11,value:'博士'},{key:12,value:'硕士'},{key:21,value:'大学'},{key:31,value:'中专(中技)'},{key:40,value:'技校'},{key:50,value:'高中'},{key:61,value:'职高'},{key:70,value:'初中'},{key:80,value:'小学'},{key:90,value:'其他'}],
areaList:[{key:'A1',value:'不限'},{key:'A2',value:'市区'},{key:'82',value:'慈溪市'},{key:'81',value:'余姚市'},{key:'83',value:'奉化市'},{key:'26',value:'宁海县'},{key:'25',value:'象山县'},{key:'A3',value:'市外'}],
/*radioValue: '不限',*/
radioValue2: '不限',
radioValue3: '不限',
name:'',
categoryList:[],
};
},
components: {
Tab,TabItem,Swiper, SwiperItem,Group,XButton,XInput,PopupRadio,Cell
},
/**
* The methods the page can use.
*/
methods: {
/**
* Will log the user in.
*
* @param {Object} user The user to be logged in.
*/
change (val, label) {
console.log('change', val, label)
},
clickItem (index) {
if(index == 1){
this.getPublicJobs();
}
},
getPublicJobs(){
let params = null
getPublicJobs(params).then((res) => {
this.categoryList = res.data;
})
},
next(){
if(this.radioValue3 == '不限'){
this.radioValue3 = 'A1'
}
this.$router.push({path: '/gw/list',query:{name:this.name,education:this.radioValue2,code:this.radioValue3,sign:0}})
}
},
mounted () {

},
/**
* The components the page can use.
*/

};



// WEBPACK FOOTER //
// ./src/pages/gw/index.vue